import { render, staticRenderFns } from "./OfferDetailsWeb.vue?vue&type=template&id=7aedeccd&scoped=true"
import script from "./OfferDetailsWeb.vue?vue&type=script&lang=ts"
export * from "./OfferDetailsWeb.vue?vue&type=script&lang=ts"
import style0 from "./OfferDetailsWeb.vue?vue&type=style&index=0&id=7aedeccd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aedeccd",
  null
  
)

export default component.exports